import { Country } from '@swf/core/enums';

export const isDenmarkCitizen = (citizenship: string) =>
  citizenship === Country.Denmark || citizenship === Country.Greenland;

export const getGenderDK = (nationalDocumentNumber: string) =>
  +nationalDocumentNumber[9] % 2 === 0 ? 'F' : 'M';
